<script>
import { mapGetters } from "vuex";
import { useAlert } from "dashboard/composables";
import validations, { getLabelTitleErrorMessage } from "./validations";
import { getRandomColor } from "dashboard/helper/labelColor";
import { useVuelidate } from "@vuelidate/core";

import NextButton from "dashboard/components-next/button/Button.vue";

export default {
  components: {
    NextButton,
  },
  props: {
    prefillTitle: {
      type: String,
      default: "",
    },
  },
  emits: ["close"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      color: "#000",
      description: "",
      title: "",
      showOnSidebar: true,
      // FORK: contextos a los que aplica la etiqueta. Deal queda opt-in.
      labelableTypes: ["conversation", "contact"],
    };
  },
  validations,
  computed: {
    ...mapGetters({
      uiFlags: "labels/getUIFlags",
    }),
    labelTitleErrorMessage() {
      const errorMessage = getLabelTitleErrorMessage(this.v$);
      return this.$t(errorMessage);
    },
  },
  mounted() {
    this.color = getRandomColor();
    this.title = this.prefillTitle.toLowerCase();
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    async addLabel() {
      try {
        await this.$store.dispatch("labels/create", {
          color: this.color,
          description: this.description,
          title: this.title.toLowerCase(),
          show_on_sidebar: this.showOnSidebar,
          labelable_types: this.labelableTypes,
        });
        useAlert(this.$t("LABEL_MGMT.ADD.API.SUCCESS_MESSAGE"));
        this.onClose();
      } catch (error) {
        const errorMessage =
          error.message || this.$t("LABEL_MGMT.ADD.API.ERROR_MESSAGE");
        useAlert(errorMessage);
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      :header-title="$t('LABEL_MGMT.ADD.TITLE')"
      :header-content="$t('LABEL_MGMT.ADD.DESC')"
    />
    <form class="flex flex-wrap mx-0" @submit.prevent="addLabel">
      <woot-input
        v-model="title"
        :class="{ error: v$.title.$error }"
        class="w-full label-name--input"
        :label="$t('LABEL_MGMT.FORM.NAME.LABEL')"
        :placeholder="$t('LABEL_MGMT.FORM.NAME.PLACEHOLDER')"
        :error="labelTitleErrorMessage"
        data-testid="label-title"
        @input="v$.title.$touch"
        @blur="v$.title.$touch"
      />

      <woot-input
        v-model="description"
        :class="{ error: v$.description.$error }"
        class="w-full"
        :label="$t('LABEL_MGMT.FORM.DESCRIPTION.LABEL')"
        :placeholder="$t('LABEL_MGMT.FORM.DESCRIPTION.PLACEHOLDER')"
        data-testid="label-description"
        @input="v$.description.$touch"
        @blur="v$.description.$touch"
      />

      <div class="w-full">
        <label>
          {{ $t("LABEL_MGMT.FORM.COLOR.LABEL") }}
          <woot-color-picker v-model="color" />
        </label>
      </div>
      <div class="w-full">
        <label>{{ $t("LABEL_MGMT.FORM.APPLIES_TO.LABEL") }}</label>
        <div class="flex flex-col gap-1 mt-1">
          <div class="flex items-center gap-2">
            <input
              v-model="labelableTypes"
              type="checkbox"
              value="conversation"
            />
            <label>{{ $t("LABEL_MGMT.FORM.APPLIES_TO.CONVERSATION") }}</label>
          </div>
          <div class="flex items-center gap-2">
            <input v-model="labelableTypes" type="checkbox" value="contact" />
            <label>{{ $t("LABEL_MGMT.FORM.APPLIES_TO.CONTACT") }}</label>
          </div>
          <div class="flex items-center gap-2">
            <input v-model="labelableTypes" type="checkbox" value="deal" />
            <label>{{ $t("LABEL_MGMT.FORM.APPLIES_TO.DEAL") }}</label>
          </div>
        </div>
      </div>
      <div class="flex items-center w-full gap-2">
        <input v-model="showOnSidebar" type="checkbox" :value="true" />
        <label for="conversation_creation">
          {{ $t("LABEL_MGMT.FORM.SHOW_ON_SIDEBAR.LABEL") }}
        </label>
      </div>
      <div class="flex items-center justify-end w-full gap-2 px-0 py-2">
        <NextButton
          faded
          slate
          type="reset"
          :label="$t('LABEL_MGMT.FORM.CANCEL')"
          @click.prevent="onClose"
        />
        <NextButton
          type="submit"
          data-testid="label-submit"
          :label="$t('LABEL_MGMT.FORM.CREATE')"
          :disabled="
            v$.title.$invalid || !labelableTypes.length || uiFlags.isCreating
          "
          :is-loading="uiFlags.isCreating"
        />
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
// Label API supports only lowercase letters
.label-name--input {
  ::v-deep {
    input {
      @apply lowercase;
    }
  }
}
</style>
